import { Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { Router } from '@angular/router';
import $ from 'jquery';

enum status {
   dataIncorrect = 'Uno de los datos o ambos son incorrectos. Verifica y vuelve a intentar.',
   expireKeyboard = 'El tiempo de espera del teclado ha vencido. Para continuar la operación, debes actualizarlo.',
   blokeckAccount = 'Por seguridad tu cuenta se encuentra bloqueada. Podrás volver a ingresar en las próximas 24 horas.',
   errorInternal = 'errorInternal'
}
@Component({
  selector: 'app-modal-parameter-alert',
  templateUrl: './modal-parameter-alert.component.html',
  styleUrls: ['./modal-parameter-alert.component.scss']
})
export class ModalParameterAlertComponent implements OnInit, OnChanges {
  modalShow: boolean = false;
  messageModal = {
    title: '',
    text: '',
    textBtn: '',
    functBtnPrimary: () => {
      null
    },
    functBtnSecond: () => {
      this.route.navigate(['/public/sign/recover'])
    },
    isBtnRecovery: false,
    isBtnTryAgain: false
  }
  constructor(public route: Router) { 
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
  }

  show(){
    this.modalShow = true;
    $('#modalParamet').removeClass('hide');
      $('#modalParamet').addClass('show');
  }

  hide(){
    this.modalShow = false;
     $('#modalParamet').removeClass('show');
      $('#modalParamet').addClass('hide');
  }

  reloadPage(){
    window.location.reload();
  }

  checkStatus(statusInfo: string){
    if((statusInfo === status.dataIncorrect.toString()) || (statusInfo.includes('son incorrectos.'))){
      this.messageModal = {
        title: 'Datos incorrectos',
        text: 'Revisa el usuario y contraseña ingresados, e intenta nuevamente.',
        textBtn: 'Intentar de nuevo',
        // @ts-ignore
        functBtnPrimary: this.hide,
        functBtnSecond: () => {
          this.route.navigate(['/public/sign/recover'])
        },
        isBtnRecovery: true,
        isBtnTryAgain: false
      }

    }else if(statusInfo === status.expireKeyboard){
      this.messageModal = {
        title: 'El teclado ha expirado',
        text: 'Actualiza la página y intenta nuevamente',
        textBtn: 'Actualizar página',
        // @ts-ignore
        functBtnPrimary: this.reloadPage,
        functBtnSecond: () => {
          this.route.navigate(['/public/sign/recover'])
        },
        isBtnRecovery: false,
        isBtnTryAgain: false
      }
    }else if(statusInfo === status.blokeckAccount){
      this.messageModal = {
        title: 'Usuario bloqueado',
        text: 'Puedes recuperar tu contraseña o esperar 24 horas para que se desbloquee.',
        textBtn: 'Recuperar contraseña',
        // @ts-ignore
        functBtnPrimary: () => {this.route.navigate(['/public/sign/recover'])},
        functBtnSecond: () => {
          $('#modalParamet').removeClass('show');
          $('#modalParamet').addClass('hide');
        },
        isBtnRecovery: false,
        isBtnTryAgain: true
      }
    }else if(statusInfo === status.errorInternal){
      this.messageModal = {
        title: 'Algo inesperado ocurrió',
        text: 'Tuvimos un inconveniente, por favor vuelve a intentar. Código de error:GEN_ALL_02',
        textBtn: 'Volver a intentar',
        // @ts-ignore
        functBtnPrimary: this.hide,
        functBtnSecond: () => {
          this.route.navigate(['/public/sign/recover'])
        },
        isBtnRecovery: false,
        isBtnTryAgain: false
      }
    }
  }

}
